'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProviderCard = require('./ProviderCard.js');

var _ProviderCard2 = _interopRequireDefault(_ProviderCard);

var _changeProviders = require('./changeProviders.scss');

var _changeProviders2 = _interopRequireDefault(_changeProviders);

var _dist = require('wix-style-react/dist/src/Icons/dist');

var _list = require('-!svg-react-loader!../../../assets/images/change-provider/list.svg');

var _list2 = _interopRequireDefault(_list);

var _closeChooseProviderReasons = require('./closeChooseProviderReasons');

var _sellerTypesIcons = require('../sellerTypesIcons.js');

var _sellerTypesIcons2 = _interopRequireDefault(_sellerTypesIcons);

var _Modal = require('wix-style-react/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types, no-script-url */
var ChangeProviderIndexComponent = function (_Component) {
  (0, _inherits3.default)(ChangeProviderIndexComponent, _Component);

  function ChangeProviderIndexComponent() {
    (0, _classCallCheck3.default)(this, ChangeProviderIndexComponent);
    return (0, _possibleConstructorReturn3.default)(this, (ChangeProviderIndexComponent.__proto__ || (0, _getPrototypeOf2.default)(ChangeProviderIndexComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(ChangeProviderIndexComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          providers = _props.providers,
          activeProviderId = _props.activeProviderId,
          hasProviderBeenSet = _props.hasProviderBeenSet,
          alert = _props.alert,
          _onLearnMore = _props.onLearnMore,
          onSelectProvider = _props.onSelectProvider,
          _onSupportLink = _props.onSupportLink,
          onCompareProviders = _props.onCompareProviders,
          onClose = _props.onClose,
          t = _props.t;


      var closeComponent = onClose ? _react2.default.createElement(
        'div',
        {
          onClick: function onClick() {
            return onClose(_closeChooseProviderReasons.closeReasons.cancel);
          },
          className: _changeProviders2.default.closeButton
        },
        _react2.default.createElement(_dist.CloseThin, { size: '12px' })
      ) : null;

      return _react2.default.createElement(
        'div',
        { className: _changeProviders2.default.container },
        closeComponent,
        _react2.default.createElement(
          'div',
          { className: _changeProviders2.default.header },
          _react2.default.createElement(
            'span',
            { className: _changeProviders2.default.h1 },
            t.getByKey('ChangeProvider_Switch_Screen_Title')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _changeProviders2.default.providers },
          providers.map(function (provider) {
            var isActive = provider.appDefId === activeProviderId && hasProviderBeenSet;

            return _react2.default.createElement(_ProviderCard2.default, {
              key: provider.appDefId,
              provider: provider,
              isActive: provider.appDefId === activeProviderId && hasProviderBeenSet,
              onLearnMore: function onLearnMore(e) {
                e.stopPropagation();
                _onLearnMore(e, provider);
              },
              onClick: function onClick(e) {
                !isActive && onSelectProvider(e, provider);
              },
              icon: _sellerTypesIcons2.default[provider.sellerType],
              onSupportLink: function onSupportLink(e) {
                return _onSupportLink(e, provider);
              },
              t: t
            });
          })
        ),
        _react2.default.createElement(
          'div',
          { className: _changeProviders2.default.bottomBar },
          _react2.default.createElement(
            'a',
            {
              href: 'javascript:void(0)',
              className: _changeProviders2.default.compareProvidersSection,
              onClick: onCompareProviders
            },
            _react2.default.createElement(
              'div',
              { className: _changeProviders2.default.comparisonIcon },
              (0, _list2.default)({ width: '16', height: '15', viewBox: '0 0 16 15' })
            ),
            _react2.default.createElement(
              'span',
              null,
              t.getByKey('ChangeProvider_Switch_Screen_Provider_Chart_Label')
            )
          )
        ),
        _react2.default.createElement(
          _Modal2.default,
          {
            isOpen: !!alert,
            onRequestClose: this.closeModal,
            scrollableContent: false,
            contentLabel: ''
          },
          alert
        )
      );
    }
  }]);
  return ChangeProviderIndexComponent;
}(_react.Component);
/* eslint-enable react/prop-types, no-script-url */

exports.default = ChangeProviderIndexComponent;